import { Form } from '@ovComponents/2-component/form/form';
import { Box, Button } from 'hephaestus/web';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type SubmitButtonProps = Omit<
  React.ComponentProps<typeof Button>,
  'loading' | 'children'
> & {
  /** @deprecated Prefer `children`. Kept for workflow call sites still passing ov `label`. */
  label?: React.ReactNode;
  children?: React.ReactNode;
  /** @deprecated Prefer `data-testid`. */
  dataTestId?: string;
  'data-testid'?: string;
};

export const WorkflowCompletionForm = (
  props: React.ComponentProps<typeof Form> & {
    submitButtonProps?: SubmitButtonProps;
    buttonFooter?: React.ReactNode;
    showSubmitButton?: boolean;
  },
) => {
  const { t } = useTranslation('shared');
  const {
    submitButtonProps = {},
    buttonFooter,
    showSubmitButton = true,
    ...rest
  } = props;
  const [disabled, setDisabled] = useState(false);

  const submit = async () => {
    setDisabled(true);
    try {
      await rest.onSubmit();
    } finally {
      setDisabled(false);
    }
  };

  const {
    label,
    children,
    dataTestId,
    'data-testid': dataTestIdAttr,
    ...buttonRest
  } = submitButtonProps;
  const buttonContent = children ?? label ?? t('submit');

  return (
    <Form {...rest} onSubmit={submit}>
      {rest.children}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        {buttonFooter}
        {showSubmitButton && (
          <Button
            {...buttonRest}
            data-testid={dataTestIdAttr ?? dataTestId}
            sx={{ mt: 3, textAlign: 'center' }}
            type='submit'
            disabled={disabled || submitButtonProps.disabled}
          >
            {buttonContent}
          </Button>
        )}
      </Box>
    </Form>
  );
};
